export default {"src":"/_next/static/media/part.8d74e1e4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};